import * as React from 'react';
import AuthenticatedRoute from '../AuthenticatedRoute';
import Dashboard from '../../pages/dashboard/Dashboard';
import ShipmentIndex from '../../pages/shipmentIndex/ShipmentIndex';
import InvoiceIndex from '../../pages/invoice/InvoiceIndex';
import ShipmentDetails from '../../pages/shipment/ShipmentDetails';
import ShipmentForm from '../../pages/shipment/ShipmentForm';
import ShipmentSummary from '../../pages/shipment/ShipmentSummary';
import ProductIndex from '../../pages/product/ProductIndex';
import ContactIndex from '../../pages/contact/ContactIndex';
import LocationIndex from '../../pages/location/LocationIndex';
import LocationDetail from '../../pages/location/LocationDetail';
import LocationForm from '../../pages/location/LocationForm';
import UserIndex from '../../pages/user/UserIndex';
import MyAccount from '../../pages/myaccount/MyAccount';
import QuickRateIndex from '../../pages/quickRate/QuickRateIndex';
import CustomFieldsIndex from '../../pages/customFields/CustomFieldsIndex';
import FilesIndex from '../../pages/files/FilesIndex';
import AccessorialsIndex from '../../pages/accessorials/AccessorialsIndex';
import GLCodesIndex from '../../pages/glcodes/GLCodesIndex';
import CancellationReasonIndex from '../../pages/cancellationReasons/CancellationReasonIndex';
import LcpIndex from '../../pages/lcp/LcpIndex';
import InvoiceDetails from '../../pages/invoice/InvoiceDetails';
import CarrierRelationshipIndex from '../../pages/carrierRelationship/CarrierRelationshipIndex';
import CarrierRelationshipForm from '../../pages/carrierRelationship/CarrierRelationshipForm';
import CarrierRelationshipDetails from '../../pages/carrierRelationship/CarrierRelationshipDetails';
import ReportsIndex from '../../pages/reports/ReportsIndex';
import CarrierPerformanceReport from '../../pages/reports/CarrierPerformance';
import InvoiceBatchesReport from '../../pages/reports/InvoiceBatches';
import InvoiceBatchDetail from '../../pages/reports/InvoiceBatchDetail';
import OrganizationsIndex from '../../pages/cs/organizations/OrganizationsIndex';
import OrganizationForm from '../../pages/organization/OrganizationForm';
import BOL from '../../pages/BOL/BOL';
import Labels from '../../pages/labels/Labels';
import SavedViewsIndex from '../../pages/savedViews/SavedViewsIndex';
import ShipmentTracking from '../../pages/unauthenticated/ShipmentTracking';
import _get from 'lodash/get';

import { ADMIN, SHIPPER, QUOTER } from '../../constants/permissions';
import { IS_PROPEL_ADMINISTRATOR_KEY } from '../../constants/constants';

import EmptyPage from '../../pages/EmptyPage';

const Routes = props => {
  const routes = [
    {
      path: '/admin/organizations',
      exact: true,
      component: OrganizationsIndex,
      isPermitted: globalProps => {
        return _get(globalProps, IS_PROPEL_ADMINISTRATOR_KEY, false);
      }
    },
    {
      path: '/organization/new',
      exact: true,
      component: OrganizationForm,
      isPermitted: globalProps => {
        return _get(globalProps, IS_PROPEL_ADMINISTRATOR_KEY, false);
      }
    },
    {
      path: '/organization/edit/:id(\\d+)',
      exact: true,
      component: OrganizationForm,
      isPermitted: (globalProps, isPermissible) => {
        return isPermissible(globalProps, ADMIN, true);
      }
    },
    {
      path: '/general',
      exact: true,
      component: OrganizationForm,
      isPermitted: (globalProps, isPermissible) => {
        return isPermissible(globalProps, ADMIN, true);
      }
    },
    {
      path: '/dashboard',
      exact: true,
      component: Dashboard
    },
    {
      path: '/shipments',
      exact: true,
      component: ShipmentIndex
    },
    {
      path: '/shipments/new',
      exact: true,
      component: ShipmentForm,
      isPermitted: (globalProps, isPermissible) => {
        return (
          isPermissible(globalProps, ADMIN, true) ||
          isPermissible(globalProps, SHIPPER, true)
        );
      }
    },
    {
      path: '/shipments/:id(\\d+)',
      exact: true,
      component: ShipmentDetails
    },
    {
      path: '/shipments/:id/map',
      exact: true,
      component: ShipmentDetails
    },
    {
      path: '/shipments/:id/edit',
      exact: true,
      component: ShipmentForm,
      isPermitted: (globalProps, isPermissible) => {
        return (
          isPermissible(globalProps, ADMIN, true) ||
          isPermissible(globalProps, SHIPPER, true)
        );
      }
    },
    {
      path: '/shipments/:id/success',
      exact: true,
      component: ShipmentSummary,
      isPermitted: (globalProps, isPermissible) => {
        return (
          isPermissible(globalProps, ADMIN, true) ||
          isPermissible(globalProps, SHIPPER, true)
        );
      }
    },
    {
      path: '/products',
      exact: true,
      component: ProductIndex,
      isPermitted: (globalProps, isPermissible) => {
        return isPermissible(globalProps, ADMIN, true);
      }
    },
    {
      path: '/contacts',
      exact: true,
      component: ContactIndex,
      isPermitted: (globalProps, isPermissible) => {
        return isPermissible(globalProps, ADMIN, true);
      }
    },
    {
      path: '/locations',
      exact: true,
      component: LocationIndex
    },
    {
      path: '/locations/new',
      exact: true,
      component: LocationForm,
      isPermitted: (globalProps, isPermissible) => {
        return isPermissible(globalProps, ADMIN, true);
      }
    },
    {
      path: '/users',
      exact: true,
      component: UserIndex,
      isPermitted: (globalProps, isPermissible) => {
        return isPermissible(globalProps, ADMIN, true);
      }
    },
    {
      path: '/myaccount',
      exact: true,
      component: MyAccount
    },
    {
      path: '/quick-rate',
      exact: true,
      component: QuickRateIndex,
      isPermitted: (globalProps, isPermissible) => {
        return (
          isPermissible(globalProps, ADMIN, true) ||
          isPermissible(globalProps, SHIPPER, true) ||
          isPermissible(globalProps, QUOTER, true)
        );
      }
    },
    {
      path: '/invoices',
      exact: true,
      component: InvoiceIndex,
      isPermitted: (globalProps, isPermissible) => {
        return (
          isPermissible(globalProps, ADMIN, true) ||
          isPermissible(globalProps, SHIPPER, true)
        );
      }
    },
    {
      path: '/invoices/:id(\\d+)',
      exact: true,
      component: InvoiceDetails,
      isPermitted: (globalProps, isPermissible) => {
        return (
          isPermissible(globalProps, ADMIN, true) ||
          isPermissible(globalProps, SHIPPER, true)
        );
      }
    },
    {
      path: '/locations/:id(\\d+)',
      exact: true,
      component: LocationDetail,
      isPermitted: (globalProps, isPermissible) => {
        return isPermissible(globalProps, ADMIN, true);
      }
    },
    {
      path: '/locations/:id(\\d+)/edit',
      exact: true,
      component: LocationForm,
      isPermitted: (globalProps, isPermissible) => {
        return isPermissible(globalProps, ADMIN, true);
      }
    },
    {
      path: '/custom-fields',
      exact: true,
      component: CustomFieldsIndex,
      isPermitted: (globalProps, isPermissible) => {
        return isPermissible(globalProps, ADMIN, true);
      }
    },
    {
      path: '/files',
      exact: true,
      component: FilesIndex,
      isPermitted: (globalProps, isPermissible) => {
        return (
          isPermissible(globalProps, ADMIN, true) ||
          isPermissible(globalProps, SHIPPER, true)
        );
      }
    },
    {
      path: '/accessorials',
      exact: true,
      component: AccessorialsIndex,
      isPermitted: (globalProps, isPermissible) => {
        return isPermissible(globalProps, ADMIN, true);
      }
    },
    {
      path: '/gl-codes',
      exact: true,
      component: GLCodesIndex
    },
    {
      path: '/cancellation-reasons',
      exact: true,
      component: CancellationReasonIndex,
      isPermitted: (globalProps, isPermissible) => {
        return isPermissible(globalProps, ADMIN, true);
      }
    },
    {
      path: '/lcp-exception-reasons',
      exact: true,
      component: LcpIndex,
      isPermitted: (globalProps, isPermissible) => {
        return isPermissible(globalProps, ADMIN, true);
      }
    },
    {
      path: '/carrier-relationships',
      exact: true,
      component: CarrierRelationshipIndex,
      isPermitted: (globalProps, isPermissible) => {
        return isPermissible(globalProps, ADMIN, true);
      }
    },
    {
      path: '/carrier-relationships/new',
      exact: true,
      component: CarrierRelationshipForm,
      isPermitted: (globalProps, isPermissible) => {
        return isPermissible(globalProps, ADMIN, true);
      }
    },
    {
      path: '/carrier-relationships/:id(\\d+)',
      exact: true,
      component: CarrierRelationshipDetails,
      isPermitted: (globalProps, isPermissible) => {
        return isPermissible(globalProps, ADMIN, true);
      }
    },
    {
      path: '/carrier-relationships/:id(\\d+)/edit',
      exact: true,
      component: CarrierRelationshipForm,
      isPermitted: (globalProps, isPermissible) => {
        return isPermissible(globalProps, ADMIN, true);
      }
    },
    {
      path: '/reports',
      exact: true,
      component: ReportsIndex
    },
    {
      path: '/reports/carrier-performance',
      exact: true,
      component: CarrierPerformanceReport
    },
    {
      path: '/reports/carrier-invoice-batches',
      exact: true,
      component: InvoiceBatchesReport,
      isPermitted: (globalProps, isPermissible) => {
        // Temporarily hide invoices while in development
        return (
          _get(globalProps, IS_PROPEL_ADMINISTRATOR_KEY, false) &&
          (isPermissible(globalProps, ADMIN, true) ||
            isPermissible(globalProps, SHIPPER, true))
        );
      }
    },
    {
      path: '/reports/carrier-invoice-batches/:id(\\d+)',
      exact: true,
      component: InvoiceBatchDetail,
      isPermitted: (globalProps, isPermissible) => {
        // Temporarily hide invoices while in development
        return (
          _get(globalProps, IS_PROPEL_ADMINISTRATOR_KEY, false) &&
          (isPermissible(globalProps, ADMIN, true) ||
            isPermissible(globalProps, SHIPPER, true))
        );
      }
    },
    {
      path: '/BOL/:id',
      exact: true,
      component: BOL,
      requiresAuthentication: false
    },
    {
      path: '/labels/:id',
      exact: true,
      component: Labels,
      requiresAuthentication: false
    },
    {
      path: '/saved-views',
      exact: true,
      component: SavedViewsIndex
    },
    {
      path: '/empty',
      exact: true,
      component: EmptyPage
    },
    {
      path: '/tracking/:id',
      exact: true,
      component: ShipmentTracking,
      requiresAuthentication: false
    }
  ];
  return (
    <div>
      {routes.map((route, index) => (
        <AuthenticatedRoute
          key={index}
          path={route.path}
          exact={route.exact}
          component={route.component}
          isPermitted={_get(route, 'isPermitted', () => {
            return true;
          })}
          requiresAuthentication={_get(route, 'requiresAuthentication', true)}
          auth={props.auth}
        />
      ))}
    </div>
  );
};

export default Routes;
